import styled from "styled-components/macro";

export const DataGridStyle = styled.div`	
flex-grow: 1;
padding: 20px 40px;
background-color: #c6c6c630;

	.DataGridWrap{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		/* border:1px solid red; */
		border-radius: 4px;

		.MuiDataGrid-root{
			background-color: #fff;
		}
	}	

	.noData {
		padding: 20px;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		height: 100%;
		color:rgb(101, 101, 101);
	}

	.download_btn{
		display: flex;
		justify-content: flex-end;
		padding: 8px 12px;
		margin: 0 0 10px auto;
		background-color: #73972c;
		color: #fff;
		border:0;
		border-radius: 4px;
		cursor: pointer;
	}
`;
